import { render, staticRenderFns } from "./BaseAddVideoForm.vue?vue&type=template&id=317615fc&scoped=true&"
import script from "./BaseAddVideoForm.vue?vue&type=script&lang=js&"
export * from "./BaseAddVideoForm.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./BaseAddVideoForm.vue?vue&type=style&index=1&id=317615fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "317615fc",
  null
  
)

export default component.exports